import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'app-maes-diogelwch-teiars',
    templateUrl: './maes-diogelwch-teiars.component.html',
    styleUrls: ['./maes-diogelwch-teiars.component.scss'],
    imports: [FormlyModule]
})
export class MaesDiogelwchTeiarsComponent extends FieldType<FieldTypeConfig> implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {

  }
}
